module.exports = __webpack_public_path__ + "img/logo.d7b736a4.png";